import React from 'react';

import {
  Datagrid,
  TextField,
  DateField,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
} from 'react-admin';

import ReferenceEntityField from '../../customFields/ReferenceEntityField';
import StatusField from '../../customFields/StatusField';
import NoResults from '../layout/NoResults';
import LinkField from '../layout/LinkField';
import { boldDataGridStyle } from '../../constants/style/datagridStyles';
import EntityDisplayNameField from '../../customFields/EntityDisplayNameField';
import { TransactionDetails } from '../request/RequestTypeForm/edit/Transaction';

const Transaction = (
  {
    children,
  }: {
    children?: React.ReactNode;
  },
) => (
  <Datagrid
    sx={boldDataGridStyle}
    bulkActionButtons={false}
    empty={<NoResults variant="h6" />}
    expand={<TransactionDetails boldTitles compact />}
  >
    <LinkField sortable={false} source="id" label="ID" />
    <DateField sortable source="extraInformation.date" showTime label="Date" />
    <TextField sortable source="extraInformation.amount" label="Amount" />
    <TextField sortable={false} source="extraInformation.currency" label="Currency" />
    <StatusField sortable={false} source="extraInformation.status" label="Status" resource="transactions" />
    <ReferenceEntityField sortable={false} source="extraInformation.processor" label="Processor">
      <EntityDisplayNameField />
    </ReferenceEntityField>
    <ReferenceEntityField sortable={false} source="extraInformation.subProcessor" label="Sub-processor">
      <EntityDisplayNameField />
    </ReferenceEntityField>
    <ReferenceEntityField sortable={false} source="extraInformation.recipient" label="Recipient">
      <EntityDisplayNameField />
    </ReferenceEntityField>
    <ReferenceEntityField sortable={false} source="extraInformation.initiator" label="Initiator">
      <EntityDisplayNameField />
    </ReferenceEntityField>
    <ReferenceArrayField sortable={false} source="extraInformation.transactionTypes" reference="transaction-types" label="Transaction types">
      <SingleFieldList linkType={false} empty={'-' as any}>
        <ChipField source="name" />
      </SingleFieldList>
    </ReferenceArrayField>
    {children}
  </Datagrid>
);

export default Transaction;
